import jwtAuthAxios from "./auth/jwtAuth";

const customerServices = {};

customerServices.getCustomers = async (params) => {
    const {data} = await jwtAuthAxios.get(`/customers${params}`);
    return data;
};

customerServices.getCustomer = async (id, params=null) => {
    const {data} = await jwtAuthAxios.get(`/customers/${id}${params ? `?${params}` : ''}`);
    return data;
};

customerServices.saveRecipients = async (id, params) => {
    const {data} = await jwtAuthAxios.post(`/customers/${id}/recipients`, params);
    return data;
};

customerServices.saveCustomerGeofence = async (id, params) => {
    const {data} = await jwtAuthAxios.post(`/customers/${id}/geofence`, params);
    return data;
};

customerServices.addCustomerAddress = async (id, params) => {
    const {data} = await jwtAuthAxios.post(`/customers/${id}/addresses`, params);
    return data;
};

customerServices.deleteCustomerAddress = async (id, addressId) => {
    const {data} = await jwtAuthAxios.delete(`/customers/${id}/addresses/${addressId}`);
    return data;
};

customerServices.setPrimaryAddress = async (id, addressId) => {
    const {data} = await jwtAuthAxios.post(`/customers/${id}/addresses/${addressId}/primary`);
    return data;
};

customerServices.saveAddressSchedules = async (id, schedules) => {
    const {data} = await jwtAuthAxios.post(`/customers/${id}/address_schedules`, { schedules });
    return data;
};

customerServices.getReceiptsPins = async (id) => {
    const {data} = await jwtAuthAxios.get(`/customers/${id}/receipts_pins`);
    return data;
};

customerServices.createCustomer = async (customerData) => {
    const {data} = await jwtAuthAxios.post('/customers', customerData);
    return data;
};

// Sin parametros trae todos. Con { q, limit } busca por nombre, codigo o alias.
customerServices.searchByCompany = async (params = {}) => {
  const { data } = await jwtAuthAxios.get('/customers/search_by_company', { params });
  return data;
};

export default customerServices;